/**
 * 服务发布消息组件
 */

import {
    Flex,
} from 'antd';

const ServiceReleaseMessage = (props) => {
    return <Flex justify='center' style={{
        textAlign: 'center',
        fontSize: '12px',
        background: 'linear-gradient(to top, #00152A,' + props.themeColor + ')',
        color: '#fff',
        height: 20.5,
        opacity: 1,
        zIndex: 999,
    }}
    ><span>{props.serInfos.length > 0 ? props.serInfos[0].content : ''}</span></Flex>
}

export default ServiceReleaseMessage;